import { useI18n } from '../../../../i18n';
import type { AssistMode, ModelOption } from './admin-ia-shared';
import { TH_STYLE, CELL_INPUT, SECTION_CARD, SECTION_TITLE } from './admin-ia-shared';
import { InfoTooltip } from '@/components/ui/InfoTooltip';

interface AdminIAAssistModesProps {
  assistModes: AssistMode[];
  modelOptions: ModelOption[];
  saving: boolean;
  onUpdateAssistMode: (idx: number, patch: Partial<AssistMode>) => void;
}

export function AdminIAAssistModes({
  assistModes,
  modelOptions,
  saving,
  onUpdateAssistMode,
}: AdminIAAssistModesProps) {
  const { t } = useI18n();
  return (
    <div style={SECTION_CARD}>
      <h3 style={{ ...SECTION_TITLE, display: 'inline-flex', alignItems: 'center' }}>
        {t.admin.ia.modos.titulo}
        <InfoTooltip title={t.admin.ia.modos.titulo} text={t.admin.ia.modos.ayuda} />
      </h3>

      {saving && (
        <div style={{ fontSize: 10, color: '#33BCE1', marginBottom: 6 }}>Guardando...</div>
      )}
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
        <thead>
          <tr>
            {['MODO', 'MODELO', 'TEMP', 'TOKENS'].map((h) => (
              <th key={h} style={TH_STYLE}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {assistModes.map((m, idx) => (
            <tr key={m.modo} style={{ backgroundColor: idx % 2 === 1 ? '#D6E4F0' : '#fff' }}>
              <td
                style={{
                  padding: '8px 12px',
                  fontWeight: 600,
                  color: '#1F3864',
                  fontSize: 11,
                }}
              >
                {m.modo}
              </td>
              <td style={{ padding: '8px 12px' }}>
                <select
                  style={{ ...CELL_INPUT, width: '100%' }}
                  value={m.modelo}
                  onChange={(e) => onUpdateAssistMode(idx, { modelo: e.target.value })}
                >
                  {modelOptions.length > 0 ? (
                    modelOptions.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))
                  ) : (
                    <option value={m.modelo}>{m.modelo}</option>
                  )}
                </select>
              </td>
              <td style={{ padding: '8px 12px' }}>
                <input
                  type="number"
                  step="0.1"
                  min="0"
                  max="1"
                  style={{ ...CELL_INPUT, width: 48 }}
                  value={m.temp}
                  onChange={(e) => onUpdateAssistMode(idx, { temp: e.target.value })}
                />
              </td>
              <td style={{ padding: '8px 12px' }}>
                <input
                  type="number"
                  step="512"
                  min="512"
                  max="32768"
                  style={{ ...CELL_INPUT, width: 60 }}
                  value={m.tokens}
                  onChange={(e) => onUpdateAssistMode(idx, { tokens: e.target.value })}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
